import { gql } from "@outschool/ui-apollo";

export default gql`
  fragment AvailabilityFragment on Availability {
    hourlyTimetable {
      mon
      tue
      wed
      thu
      fri
      sat
      sun
    }
    updated_at
  }
`;
